import React, { useState } from "react";

import { Button, Card, Col, Row } from "react-bootstrap";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const categoriesName = ["Speaking", "Writing", "Reading", "Listening"];

const MockInfo = ({
  setShowMockInfo,
  initialTime,
  categoriesData,
  category,
}) => {
  const [, forceUpdate] = useState();
  const categoryName = categoriesName[category - 1];


  const subCategoriesNames = categoriesData
    .sort((a, b) => {
      return a.order - b.order;
    })
    .map((subCategory) => {
      return (
        <li
          style={{ textTransform: "capitalize" }}
          key={subCategory.sub_categories.id}
        >
          {subCategory.sub_categories.title}
        </li>
      );
    });

  return (
    <div className="content questionsArea deviceTestPage old-design m-0 p-0" id="test-card">
      <Row className="test_width mock-header-gap">
        <Col xs={12} className="p-0">
          <div className="border-top-0 bg-transparent">
            <div className="p-0">
              <div
                className="d-flex align-items-end flex-column gap-1 rounded-2 mock-header-gap"
                // style={{ backgroundColor: "white" }}
              >
                <div
                  className="d-flex justify-content-between align-items-center w-100 mock-header-bg"
                  style={{
                    // backgroundColor: "#BFBABB",
                    height: "40px",
                  }}
                >
                  <div style={{ width: "fit-content", padding: "20px" }} className="mock-resource-text">
                    <h4 className="m-0">Extensive Mock Test</h4>
                  </div>
                </div>

                <div
                  className="d-flex justify-content-end align-items-center px-4 w-100"
                  style={{
                    backgroundColor: "#0081A4",
                    minHeight: "40px",
                  }}
                >
                  <div className="d-flex justify-content-end gap-3">
                    <img
                      src={isFullScreen() ? ExitFullScreen : FullScreen}
                      onClick={() => {
                      toggleFullScreen();
                      setTimeout(() => {
                        forceUpdate({});
                      }, 100);
                      }}
                      alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
                      className="toggle-icons"
                    />
                    <img
                      src={isDarkMode() ? LightMode : DarkMode}
                      onClick={() => {
                      toggleTheme();
                      forceUpdate({});
                      }}
                      alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
                      className="toggle-icons"
                    />		
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} className="p-0 test_width">
          {/* style={{ minHeight: "80vh" }}  */}
          <Card className="border-0 mock-container" id="extensive-mock-test">
            <Card.Header>
              {/* <CardTitle tag="h4">
                Sectional Mock Test - {categoryName} Module
              </CardTitle> */}
            </Card.Header>
            <Card.Body style={{padding: '20px 40px 10px !important'}} className="mock-resource-text" >
              <div>
                <h4 className="mt-0" >Sectional Mock Test - {categoryName} Module</h4>
              </div>
              <div className="mb-3">
                <h6>This Mock Test will contain the following questions:</h6>
              </div>
              <ul style={{ listStyle: "circle" }}>{subCategoriesNames}</ul>
              <div className="mt-4">
                <div className="my-3">
                  <h6>Time Allowed: <b>{initialTime} minutes</b></h6>
                </div>
                <div className="my-3">
                  <h6>Please note that all the questions appearing in this mock
                    contribute to the {categoryName} score.</h6>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12}>
          <div className="bottom-0 bottomBtns justify-content-center m-0 p-0 position-fixed w-101 mock-header-gap">
            <Row className="gap-1 w-100 m-0 align-items-center">
              <Col className="bottom-btn-color mock-bottom-btn-toggle bottom-btn-width-resource-1 flex-grow-1"
              ></Col>
              <Col
                xs="auto"
                className="d-flex justify-content-center align-items-center bottom-btn-color checkResourceButtons mock-bottom-btn-toggle bottom-btn-width-resource-2"
                style={{ minWidth: "20%" }}
              >
                <Button
                  color="primary"
                  size="xs"
                  onClick={() => setShowMockInfo(false)}
                  className="mock-btn bottomBtnFont d-flex align-items-center"
                >
                  Next
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
        {/* <Col xs={12}>
          <div className="bottomBtns">
            <Row>
              <Col xs={9}></Col>
              <Col xs={3}>
                <Button
                  color="primary"
                  size="xs"
                  onClick={() => setShowMockInfo(false)}
                >
                  Next
                </Button>
              </Col>
            </Row>
          </div>
        </Col> */}
      </Row>
    </div>
  );
};

export default MockInfo;
